export default "__VITE_ASSET__rQ7jkl9G__"